module.exports = __webpack_public_path__ + "img/2023-13.a9320174.jpg";